var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.461,
    height: 43.461,
    viewBox: "0 0 43.461 43.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 21.73,
    cy: 21.73,
    r: 21.73,
    transform: "translate(0.002 0.002)",
    fill: "#cb0b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M531.189,329.115a21.73,21.73,0,0,1,21.73-21.731c12,0,12,43.461,0,43.461A21.731,21.731,0,0,1,531.189,329.115Z",
    transform: "translate(-531.189 -307.384)",
    fill: "#d2181c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(8.238 4.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M551.969,319.354l1.014,3.122h3.283l-2.656,1.929,1.015,3.122-2.656-1.929-2.656,1.929,1.015-3.122-2.656-1.929h3.282Z",
    transform: "translate(-547.672 -317.578)",
    fill: "#ffc618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M569.227,315.8l-.32,1.1.942.643-1.14.033-.319,1.1L568,317.594l-1.14.035.9-.7-.385-1.074.943.643Z",
    transform: "translate(-557.272 -315.801)",
    fill: "#ffc618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M569.227,335.426l-.32,1.095.942.643-1.14.034-.319,1.1L568,337.219l-1.14.035.9-.7-.385-1.074.943.642Z",
    transform: "translate(-557.272 -325.617)",
    fill: "#ffc618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M574.789,321.783l-.32,1.1.943.643-1.14.034-.32,1.1-.385-1.074-1.14.035.9-.7-.385-1.074.943.643Z",
    transform: "translate(-560.055 -318.793)",
    fill: "#ffc618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M574.789,329.783l-.32,1.1.943.643-1.14.034-.32,1.1-.385-1.074-1.14.035.9-.7-.385-1.074.943.642Z",
    transform: "translate(-560.055 -322.795)",
    fill: "#ffc618"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.06739126a9d837cbceb77c89ffc1b6ce.svg";
export { ForwardRef as ReactComponent };